import React from "react";
import Logicalobject from "../../../assets/images/Blogs/LogicalObject/LogicalObjectDiagram.PNG";
import logicalstep2 from "../../../assets/images/Blogs/LogicalObject/logicalstep1diagram.PNG";
import logicalstep3 from "../../../assets/images/Blogs/LogicalObject/Logicalstep3diagram.PNG";
import logicalstep4 from "../../../assets/images/Blogs/LogicalObject/logicalstep4diagram.PNG";
import logicalstep5 from "../../../assets/images/Blogs/LogicalObject/logicalstep5diagram.PNG";
import logicalstep6 from "../../../assets/images/Blogs/LogicalObject/logicalstep6diagram.PNG";
import logicalstep7 from "../../../assets/images/Blogs/LogicalObject/logicalstep7diagram.PNG";
import logicalstep9 from "../../../assets/images/Blogs/LogicalObject/logicalstep9diagram.PNG";
import logicalstep10 from "../../../assets/images/Blogs/LogicalObject/logicalstep10diagram.PNG";
import logicalstep12 from "../../../assets/images/Blogs/LogicalObject/logicalstep12diagram.PNG";
import logicalstep13 from "../../../assets/images/Blogs/LogicalObject/logicalstep13diagram.PNG";
import logicalstep13to1 from "../../../assets/images/Blogs/LogicalObject/logicalstep13diagram2.PNG";

const LogicalObjectPost = () => {
  return (
    <>
      <section className="banner-audit">
        <h1 className="banner-title">Logical Object Post</h1>
      </section>

      <section>
        <p>
        Simplified Attributes Synchronization through Logical Objects in Active Workspace 
        </p>
        <p>
        Logical Objects in Active Workspace has Simplified the Attributes Synchronization between Teamcenter and other Applications 
        </p>
        <p>
        (Logical object to synchronize attributes between Teamcenter and Microsoft Office files)  

        (Defining attribute mappings get simpler and could be done by an end-user (maybe not define the input items, but at least add/remove attributes) )
        </p>

        <img src={Logicalobject} alt="Logical object diagram" />
        <p>
        Attributes synchronization is required to ensure that up-to-date information is available in the Teamcenter environment and in other application files (such as Microsoft Office, PDF).
        </p>
        <p>
        A logical object is a runtime object designed to consolidate properties from related objects into a single place. It represents logical views of complex data models in terms of a simplified structure of members and properties. It eliminates the need for the end-user to know the data model by presenting a flat list of properties. 
        </p>
        <p>
        Let’s see how to enable attribute synchronization between Teamcenter and Microsoft Office files (similarly you can do it for XLS, PPT, PDF, etc). 
        </p>

        <p>
            <strong>Step1 : </strong> Install the “Logical Object” feature that is available under “Active Architect” using Deployment Center or TEM
        </p>

        <p>
            <strong>Step2 : </strong> Launch Active Workspace Client and define logical object root as “MS WordX” dataset as we want to fetch the properties from Document Revision to MS Word X dataset that is going to be attached to Document Revision with TC_Attaches relation 
        </p>
        <img src={logicalstep2} alt="" />

        <p>
            <strong>Step3 : </strong> Create the Document Management Template and attach MS WordX file to it  
        </p>

        <img src={logicalstep3} alt="" />

        <p>
            <strong>Step4 : </strong> Link “Logical Object” created in the Step1   
        </p>
        <img src={logicalstep4} alt="" />
        <p>
            <strong>Step5 : </strong> Open the MS WordX document and define the custom properties that you want to synchronize with Teamcenter from the MS WordX file. 

To define custom properties, you must launch the MS application and go to the info and look for properties, and then “Advanced properties”   
        </p>

        <img src={logicalstep5} alt="" />

        <p>
            <strong>Step6 : </strong> Embed those properties in the MSWord X file and save it   
        </p>
        <img src={logicalstep6} alt="" />

        <p>
            <strong>Step7 : </strong> Release the “Document Management Template” 
        </p>

        <img src={logicalstep7} alt="" />

        <p>
            <strong>Step8 : </strong> Create custom document type with required custom properties (This is optional you can use the existing OOTB document type also) 
        </p>

        <p>
            <strong>Step9 : </strong> Define IRDC for custom Document Revision 
        </p>
        <img src={logicalstep9} alt="" />

        <p>
            <strong>Step10 : </strong> Define the below business constant on Item Revision required to  
        </p>
        <img src={logicalstep10} alt="" />

        <p>
            <strong>Step11 : </strong> Deploy the template  
        </p>

        <p>
            <strong>Step12 : </strong>  Define the workflow as below (Important Note: At present, I see if you don’t fill the attribute during object creation, you have to explicitly run this workflow to synchronize the attribute) 
        </p>
        <img src={logicalstep12} alt="" />

        <p>
            <strong>Step13 : </strong>  The system is ready for usage, create the custom Item that will get created along with the MS WordX dataset (This happens through the Document management template through IRDC). 

(As mentioned above, if you fill the attributes during object creation you get those synchronized automatically, else you have to run the above workflow) 
        </p>
        <img src={logicalstep13} alt="" />
        <p>
        When you open the document, you will see the attributes synchronized from Teamcenter to file  
        </p>
        <img src={logicalstep13to1} alt="" />

      </section>

      <section>
        <h4>Benefits : </h4>

        <ul>
            <li>Logical objects made attribute mappings way simpler than the traditional method  </li>
            <li>Logical objects enable attribute mapping to apply automatically to all the document instances (unlike the old approach that required an individual document update )</li>
            <li>Logical objects eliminate the need for client-side deployment required in the old approach  </li>
         
        </ul>
        <h4>
        I don't know the official standing of LCS regarding this, but what I see as advantages: 
        </h4>
      </section>
    </>
  );
};

export default LogicalObjectPost;
